import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { optionConsiderarClienteAnaliseMercado, optionConsiderarMeta } from './grupo-classificacao-config-multiselect-options';

@Component({
    selector: 'sgt-grupo-classificacao-config-multiselect',
    templateUrl: './grupo-classificacao-config-multiselect.component.html',
    styleUrls: ['./grupo-classificacao-config-multiselect.component.less']
})
export class GrupoClassificacaoConfigMultiselectComponent implements OnInit {
    /** Configurações selecionadas */
    configuracoes: number[];
    /** Ao alterar as configurações */
    @Output() configuracoesChange = new EventEmitter<void>();

    // Considerar Análise de Mercado Potencial
    @Input() isShowConsiderarClienteAnaliseMercado = true;
    @Input() considerarClienteAnaliseMercado: boolean;
    @Output() considerarClienteAnaliseMercadoChange = new EventEmitter<boolean>();

    // Considerar Meta
    @Input() isShowConsiderarMeta = true;
    @Input() considerarMeta: boolean;
    @Output() considerarMetaChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Configuração';
    @Input() checked = 'Configuração'
    @Input() checkedPlural = 'Configurações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma configuração encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-grupo-classificacao-config ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as configurações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Considerar Análise de Mercado
        if (this.isShowConsiderarClienteAnaliseMercado) {
            selects.push({
                id: optionConsiderarClienteAnaliseMercado.id,
                name: optionConsiderarClienteAnaliseMercado.nome,
                classes: 'multiselect-item-grupo-classificacao-config multiselect-item-grupo-classificacao-config-considerar-analise-mercado-potencial'
            });
        }

        // Considerar Meta
        if (this.isShowConsiderarMeta) {
            selects.push({
                id: optionConsiderarMeta.id,
                name: optionConsiderarMeta.nome,
                classes: 'multiselect-item-grupo-classificacao-config multiselect-item-grupo-classificacao-config-considerar-meta'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das configurações */
    onChange() {
        // Considerar Análise de Mercado Potencial
        this.considerarClienteAnaliseMercado = this.configuracoes.includes(optionConsiderarClienteAnaliseMercado.id) ? true : null;
        this.considerarClienteAnaliseMercadoChange.emit(this.considerarClienteAnaliseMercado);

        // Considerar Meta
        this.considerarMeta = this.configuracoes.includes(optionConsiderarMeta.id) ? true : null;
        this.considerarMetaChange.emit(this.considerarMeta);

        this.configuracoesChange.emit();
    }
}
